import {
  isMobileOnly,
  isAndroid,
  isIOS,
  isWinPhone,
  osVersion,
  isChrome,
} from 'react-device-detect';

export const isMobile = (function (): boolean {
  let isMobile = isMobileOnly;
  try {
    if (typeof window !== 'undefined') {
      const url = new URL(window.location.href);
      if (url.searchParams.get('ewIsMobile') === '1') {
        isMobile = true;
        const userAgent = `Mozilla/5.0 (iPhone; CPU iPhone OS 17_0_3 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/17.0 Mobile/15E148 Safari/604.1`;
        const userAgentProp = {
          get: function () {
            return userAgent;
          },
        };
        try {
          Object.defineProperty(window.navigator, 'userAgent', userAgentProp);
        } catch (e) {
          window.navigator = Object.create(navigator, {
            userAgent: userAgentProp,
          });
        }
      }
    }
  } catch {
    // Do nothing
  }
  if (typeof window === 'undefined') return isMobileOnly;
  return isMobile;
})();
export const isDevice = isAndroid || isIOS || isWinPhone;
export const isIOSDevice = isMobileOnly && isIOS;
export const iOSVersion = osVersion;
export const isChromeMobile = isMobileOnly && isChrome;
export const isGoogleSearchApp = isMobileOnly && /GSA/.test(navigator.userAgent);

export default isMobile;
